import React from 'react';
import { gql } from '@reverbdotcom/commons/src/gql';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Listing } from '@reverbdotcom/commons/src/gql/graphql';
import I18n from 'i18n-js';
import { Paths } from '../shared/url_helpers';
import { ArrowRightIcon } from '@reverbdotcom/cadence/icons/react';

interface IExternalProps {
  listing: Listing;
}

export const SellerListingCardTradeInFragment = gql(`
  fragment SellerListingCardTradeInFooter on Listing {
    _id
    id
    tradeInEligibility {
      isEligible
    }
    csp {
      _id
      id
    }
    canonicalProductId
  }
`);

export default function SellerListingCardTradeInFooter({ listing }: IExternalProps) {
  if (!listing.tradeInEligibility.isEligible || !listing.csp?.id) {
    return null;
  }

  const tradeInPath = Paths.sellerTradeIn.expand({
    listing_id: listing.id,
    csp_seed_id: listing.csp?.id,
    cp_id: listing?.canonicalProductId,
  });

  return (
    <CoreLink to={tradeInPath}>
      <div className="seller-listing-card-trade-in-footer">
        {I18n.t('discovery.tradeIn.sellerListingCardCallout')}
        <span className="seller-listing-card-trade-in-footer__icon">
          <ArrowRightIcon />
        </span>
      </div>
    </CoreLink>
  );
}
